<div class="ppg-c-inline-image ppg-c-inline-image--{{ content().position }}">
  @if (content().imageWithColorsUsed; as imageWithColorsUsed) {
    <ppg-image-with-colors-used [content]="imageWithColorsUsed.content" />
  } @else {
    @if (content().image; as image) {
      <ppg-image [url]="image.url" [width]="image.width" [height]="image.height" />
    }
  }
</div>
